import React from 'react';
import cx from 'classnames';
import styles from './ListItem.module.scss';

const ListItem = (props) => {
  const {
    after,
    children,
    className,
    onClick,
    disabled,
    ...rest
  } = props;
  return (
    <div
      className={cx(styles.list__item, {
        [styles[className]]: !!className,
        'is-disabled': !!disabled,
      })}
      onClick={onClick}
      {...rest}
    >
      {children}
      {after && <div className={styles.list__item_after}>{after}</div>}
    </div>
  );
};

export default ListItem;
